import React from 'react';

function ToggleButton({ isExpanded, clickHandler, config }) {
  const { toggleButtonLanguage } = config;

  return (
    <button
      className={`mn_quickLinksTrayToggle ${!isExpanded ? 'mn_active' : ''}`}
      aria-label="Toggle tray navigation"
      aria-expanded={!!isExpanded}
      aria-controls="mn_quickLinksTrayContent"
      onClick={clickHandler}
    >
      {toggleButtonLanguage}
    </button>
  );
}

export default ToggleButton;
